import moment from "moment";
import styles from './tile-item.module.css';
import routes from '../../utils/routes';

function ArticleTile({ content, author, first_published_at, slug, ...props}) {

  return (
    <li className={styles.tileItem}>
      <img
        className={styles.image}
        alt={content?.banner_image?.alt || ''}
        src={content?.banner_image?.filename || ''}
        width={384}
        height={312}
      />
      <div className={styles.subtitle}>{content?.type}</div>
      <div className={styles.title}>
          <a href={`${routes?.news}/${slug}`} className={styles.tileItemLink}>{content?.title}</a>
      </div>
      <div className={styles.content}>{content?.short_brief}</div>
      {(!!content?.author || !!first_published_at) && (
        <div className={styles.articleFooter}>
          {!!content?.author && <div className={styles.articleFooterItem}>{content?.author[0]?.name}</div>}
          <div className={styles.articleFooterItem}>{moment(first_published_at).format('MMM DD, yyyy')}</div>
        </div>
      )}
    </li>
  );
}

export default ArticleTile;
